import {RefObject} from "react";

import {UnsavedIndicator} from "@/components/unsavedIndicator/UnsavedIndicator.tsx";
import {MetricsExplorerQueryInput} from "@/lib/types/metricsExplorer.ts";
import {ExportChartButton} from "@/pages/metricsExplorer/actions/ExportChartButton.tsx";
import {SaveChartButton} from "@/pages/metricsExplorer/actions/SaveChartButton.tsx";

interface MetricsExplorerActionsProps {
  query: MetricsExplorerQueryInput | null;
  checkNames: Record<number, string>;
  chartRef: RefObject<HTMLDivElement | null>;
  canSave: boolean;
  isUnsaved: boolean;
  onSave: () => void;
  onSaveAs: () => void;
}

export const MetricsExplorerActions = ({
  query,
  checkNames,
  chartRef,
  canSave,
  isUnsaved,
  onSave,
  onSaveAs,
}: MetricsExplorerActionsProps) => (
  <div className="d-flex gap-3 align-items-center">
    {isUnsaved && <UnsavedIndicator />}
    <ExportChartButton query={query} checkNames={checkNames} chartRef={chartRef} />
    <SaveChartButton canSave={canSave} onSave={onSave} onSaveAs={onSaveAs} />
  </div>
);
